var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-card",
    [
      [
        _c(
          "div",
          { staticClass: "filter-container" },
          [
            _c(
              "el-form",
              {
                staticClass: "filter-form",
                attrs: { inline: true, model: _vm.listQuery },
              },
              [
                _c(
                  "el-form-item",
                  [
                    _c("el-input", {
                      attrs: { placeholder: "请输入活动标题", clearable: "" },
                      nativeOn: {
                        keyup: function ($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          ) {
                            return null
                          }
                          return _vm.handleFilter($event)
                        },
                      },
                      model: {
                        value: _vm.listQuery.title,
                        callback: function ($$v) {
                          _vm.$set(_vm.listQuery, "title", $$v)
                        },
                        expression: "listQuery.title",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  [
                    _c(
                      "el-select",
                      {
                        attrs: { placeholder: "请选择类型", clearable: "" },
                        model: {
                          value: _vm.listQuery.type,
                          callback: function ($$v) {
                            _vm.$set(_vm.listQuery, "type", $$v)
                          },
                          expression: "listQuery.type",
                        },
                      },
                      [
                        _c("el-option", {
                          attrs: { label: "会员中心轮播", value: 0 },
                        }),
                        _vm._v(" "),
                        _c("el-option", {
                          attrs: { label: "个人中心轮播", value: 5 },
                        }),
                        _vm._v(" "),
                        _c("el-option", { attrs: { label: "积分", value: 1 } }),
                        _vm._v(" "),
                        _c("el-option", { attrs: { label: "充值", value: 2 } }),
                        _vm._v(" "),
                        _c("el-option", { attrs: { label: "畅饮", value: 3 } }),
                        _vm._v(" "),
                        _c("el-option", { attrs: { label: "社区", value: 4 } }),
                        _vm._v(" "),
                        _c("el-option", {
                          attrs: { label: "券膨胀", value: 6 },
                        }),
                        _vm._v(" "),
                        _c("el-option", {
                          attrs: { label: "小红书活动Banner", value: 7 },
                        }),
                        _vm._v(" "),
                        _c("el-option", {
                          attrs: { label: "小红书创作指南（员工）", value: 8 },
                        }),
                        _vm._v(" "),
                        _c("el-option", {
                          attrs: { label: "小红书创作指南（顾客）", value: 9 },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  [
                    _c(
                      "el-select",
                      {
                        attrs: { placeholder: "请选择跳转类型", clearable: "" },
                        model: {
                          value: _vm.listQuery.linkType,
                          callback: function ($$v) {
                            _vm.$set(_vm.listQuery, "linkType", $$v)
                          },
                          expression: "listQuery.linkType",
                        },
                      },
                      [
                        _c("el-option", {
                          attrs: { label: "小程序", value: 0 },
                        }),
                        _vm._v(" "),
                        _c("el-option", {
                          attrs: { label: "gaga社区", value: 1 },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  [
                    _c(
                      "el-select",
                      {
                        attrs: { placeholder: "是否启用", clearable: "" },
                        model: {
                          value: _vm.listQuery.enabled,
                          callback: function ($$v) {
                            _vm.$set(_vm.listQuery, "enabled", $$v)
                          },
                          expression: "listQuery.enabled",
                        },
                      },
                      [
                        _c("el-option", {
                          attrs: { label: "启用", value: true },
                        }),
                        _vm._v(" "),
                        _c("el-option", {
                          attrs: { label: "禁用", value: false },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  [
                    _c(
                      "el-link",
                      {
                        staticStyle: { "margin-right": "10px" },
                        attrs: { type: "primary" },
                        on: { click: _vm.toggleAdvanced },
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.showAdvanced ? "收起" : "高级筛选") +
                            "\n          "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary", icon: "el-icon-search" },
                        on: { click: _vm.handleFilter },
                      },
                      [_vm._v("\n            搜索\n          ")]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-button",
                      {
                        attrs: {
                          type: "primary",
                          icon: "el-icon-circle-plus-outline",
                        },
                        on: { click: _vm.handleCreate },
                      },
                      [_vm._v("\n            新建活动\n          ")]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "el-form",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.showAdvanced,
                    expression: "showAdvanced",
                  },
                ],
                staticClass: "filter-form",
                attrs: { inline: true },
              },
              [
                _c(
                  "el-form-item",
                  [
                    _c(
                      "el-select",
                      {
                        attrs: { placeholder: "是否会员", clearable: "" },
                        model: {
                          value: _vm.listQuery.isVip,
                          callback: function ($$v) {
                            _vm.$set(_vm.listQuery, "isVip", $$v)
                          },
                          expression: "listQuery.isVip",
                        },
                      },
                      [
                        _c("el-option", { attrs: { label: "是", value: 1 } }),
                        _vm._v(" "),
                        _c("el-option", { attrs: { label: "否", value: 0 } }),
                        _vm._v(" "),
                        _c("el-option", { attrs: { label: "不限", value: 6 } }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  [
                    _c(
                      "el-select",
                      {
                        attrs: { placeholder: "是否添加企微", clearable: "" },
                        model: {
                          value: _vm.listQuery.isAddedWecom,
                          callback: function ($$v) {
                            _vm.$set(_vm.listQuery, "isAddedWecom", $$v)
                          },
                          expression: "listQuery.isAddedWecom",
                        },
                      },
                      [
                        _c("el-option", { attrs: { label: "是", value: 1 } }),
                        _vm._v(" "),
                        _c("el-option", { attrs: { label: "否", value: 0 } }),
                        _vm._v(" "),
                        _c("el-option", { attrs: { label: "不限", value: 6 } }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  [
                    _c(
                      "el-select",
                      {
                        attrs: { placeholder: "是否下单", clearable: "" },
                        model: {
                          value: _vm.listQuery.hasOrdered,
                          callback: function ($$v) {
                            _vm.$set(_vm.listQuery, "hasOrdered", $$v)
                          },
                          expression: "listQuery.hasOrdered",
                        },
                      },
                      [
                        _c("el-option", { attrs: { label: "是", value: 1 } }),
                        _vm._v(" "),
                        _c("el-option", { attrs: { label: "否", value: 0 } }),
                        _vm._v(" "),
                        _c("el-option", { attrs: { label: "不限", value: 6 } }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  [
                    _c(
                      "el-select",
                      {
                        attrs: { placeholder: "新人券是否过期", clearable: "" },
                        model: {
                          value: _vm.listQuery.isNewCouponExpired,
                          callback: function ($$v) {
                            _vm.$set(_vm.listQuery, "isNewCouponExpired", $$v)
                          },
                          expression: "listQuery.isNewCouponExpired",
                        },
                      },
                      [
                        _c("el-option", { attrs: { label: "是", value: 1 } }),
                        _vm._v(" "),
                        _c("el-option", { attrs: { label: "否", value: 0 } }),
                        _vm._v(" "),
                        _c("el-option", { attrs: { label: "不限", value: 6 } }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
      ],
      _vm._v(" "),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.listLoading,
              expression: "listLoading",
            },
          ],
          staticStyle: { width: "100%" },
          attrs: {
            "max-height": _vm.maxHeight,
            data: _vm.activityList,
            stripe: "",
            border: "",
            fit: "",
            "highlight-current-row": "",
          },
        },
        [
          _c("el-table-column", {
            attrs: { label: "活动标题", prop: "title", align: "center" },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              label: "活动说明",
              prop: "description",
              align: "center",
              "show-overflow-tooltip": "",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "类型", prop: "type", align: "center" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (ref) {
                  var row = ref.row
                  return [
                    _c("span", [
                      _vm._v(
                        "\n          " +
                          _vm._s(
                            {
                              0: "会员中心轮播",
                              1: "积分",
                              2: "充值",
                              3: "畅饮",
                              4: "社区",
                              5: "个人中心轮播",
                              6: "券膨胀",
                              7: "小红书活动Banner",
                              8: "小红书创作指南（员工）",
                              9: "小红书创作指南（顾客）",
                            }[row.type] || "未知"
                          ) +
                          "\n        "
                      ),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              label: "活动图片",
              prop: "imageUrl",
              align: "center",
              "min-width": "200",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (ref) {
                  var row = ref.row
                  return [
                    !row.imageUrl
                      ? _c("span", [_vm._v("未上传图片")])
                      : _c("el-image", {
                          staticStyle: { width: "80px", height: "40px" },
                          attrs: {
                            src: _vm.resPath + row.imageUrl,
                            fit: "contain",
                            "preview-src-list": [_vm.resPath + row.imageUrl],
                            "preview-teleported": "",
                          },
                        }),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              label: "跳转类型",
              prop: "linkType",
              align: "center",
              width: "96px",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (ref) {
                  var row = ref.row
                  return [
                    row.linkType === 0
                      ? _c("el-tag", { attrs: { type: "success" } }, [
                          _vm._v("小程序"),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    row.linkType === 1
                      ? _c("el-tag", [_vm._v("gaga社区")])
                      : _vm._e(),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              label: "跳转路径/链接",
              prop: "linkValue",
              align: "center",
              "show-overflow-tooltip": "",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              label: "排序",
              sortable: "",
              prop: "sortOrder",
              align: "center",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "是否会员", prop: "isVip", align: "center" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (ref) {
                  var row = ref.row
                  return [
                    _c("span", [
                      _vm._v(
                        "\n          " +
                          _vm._s(
                            {
                              1: "是",
                              0: "否",
                              6: "不限",
                            }[row.isVip] || "未知"
                          ) +
                          "\n        "
                      ),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              label: "会员等级",
              prop: "vipLevelStr",
              align: "center",
              "show-overflow-tooltip": "",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (ref) {
                  var row = ref.row
                  return [
                    _c("span", [
                      _vm._v(_vm._s(_vm.getVipLevelNames(row.vipLevelStr))),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              label: "是否添加企微",
              prop: "isAddedWecom",
              align: "center",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (ref) {
                  var row = ref.row
                  return [
                    _c("span", [
                      _vm._v(
                        "\n          " +
                          _vm._s(
                            {
                              1: "是",
                              0: "否",
                              6: "不限",
                            }[row.isAddedWecom] || "未知"
                          ) +
                          "\n        "
                      ),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "是否下过单", prop: "hasOrdered", align: "center" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (ref) {
                  var row = ref.row
                  return [
                    _c("span", [
                      _vm._v(
                        "\n          " +
                          _vm._s(
                            {
                              1: "是",
                              0: "否",
                              6: "不限",
                            }[row.hasOrdered] || "未知"
                          ) +
                          "\n        "
                      ),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              label: "新人券过期",
              prop: "isNewCouponExpired",
              align: "center",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (ref) {
                  var row = ref.row
                  return [
                    _c("span", [
                      _vm._v(
                        "\n          " +
                          _vm._s(
                            {
                              1: "是",
                              0: "否",
                              6: "不限",
                            }[row.isNewCouponExpired] || "未知"
                          ) +
                          "\n        "
                      ),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "生效开始时间", align: "center", width: "100px" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (ref) {
                  var row = ref.row
                  return [
                    _c("div", [
                      _vm._v(
                        _vm._s(
                          _vm._f("parseTime")(
                            row.startTime,
                            "{y}-{m}-{d} {h}:{i}:{s}"
                          )
                        )
                      ),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "生效截止时间", align: "center", width: "100px" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (ref) {
                  var row = ref.row
                  return [
                    _c("div", [
                      _vm._v(
                        _vm._s(
                          _vm._f("parseTime")(
                            row.endTime,
                            "{y}-{m}-{d} {h}:{i}:{s}"
                          )
                        )
                      ),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "启用状态", align: "center" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (ref) {
                  var row = ref.row
                  return [
                    _c("el-switch", {
                      attrs: {
                        "active-color": "#13ce66",
                        "inactive-color": "#ff4949",
                      },
                      on: {
                        change: function ($event) {
                          return _vm.handleStatusChange(row.id, row.enabled)
                        },
                      },
                      model: {
                        value: row.enabled,
                        callback: function ($$v) {
                          _vm.$set(row, "enabled", $$v)
                        },
                        expression: "row.enabled",
                      },
                    }),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "创建时间", align: "center", width: "100px" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (ref) {
                  var row = ref.row
                  return [
                    _c("span", [
                      _vm._v(
                        _vm._s(
                          _vm._f("parseTime")(
                            row.createTime,
                            "{y}-{m}-{d} {h}:{i}:{s}"
                          )
                        )
                      ),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "更新时间", align: "center", width: "100px" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (ref) {
                  var row = ref.row
                  return [
                    _c("span", [
                      _vm._v(
                        _vm._s(
                          _vm._f("parseTime")(
                            row.updateTime,
                            "{y}-{m}-{d} {h}:{i}:{s}"
                          )
                        )
                      ),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              fixed: "right",
              label: "操作",
              align: "center",
              width: "200",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (ref) {
                  var row = ref.row
                  return [
                    _c(
                      "el-button",
                      {
                        attrs: {
                          size: "mini",
                          type: "primary",
                          icon: "el-icon-edit",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.handleUpdate(row)
                          },
                        },
                      },
                      [_vm._v("\n          编辑\n        ")]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-button",
                      {
                        attrs: {
                          size: "mini",
                          type: "danger",
                          icon: "el-icon-delete",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.handleDelete(row)
                          },
                        },
                      },
                      [_vm._v("\n          删除\n        ")]
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _vm._v(" "),
      _vm.total > 0
        ? _c("sw-page", {
            attrs: {
              listQuery: _vm.listQuery,
              total: _vm.total,
              pos: "btmRight",
            },
            on: { retPage: _vm.getList },
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "el-drawer",
        {
          staticStyle: { overflow: "auto" },
          attrs: {
            title: _vm.dialog.status === "create" ? "新建活动" : "编辑活动",
            visible: _vm.dialog.visible,
            direction: "rtl",
            size: "44%",
            "before-close": _vm.handleDrawerClose,
            wrapperClosable: false,
          },
          on: {
            "update:visible": function ($event) {
              return _vm.$set(_vm.dialog, "visible", $event)
            },
          },
        },
        [
          _c("div", { staticClass: "drawer-container" }, [
            _c(
              "div",
              { staticClass: "scrollable-content" },
              [
                _c(
                  "el-form",
                  {
                    ref: "form",
                    attrs: {
                      model: _vm.formData,
                      rules: _vm.rules,
                      "label-width": "100px",
                    },
                  },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: "活动标题",
                          prop: "title",
                          "label-width": "120px",
                        },
                      },
                      [
                        _c("el-input", {
                          model: {
                            value: _vm.formData.title,
                            callback: function ($$v) {
                              _vm.$set(_vm.formData, "title", $$v)
                            },
                            expression: "formData.title",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: "活动说明",
                          prop: "description",
                          "label-width": "120px",
                        },
                      },
                      [
                        _c("el-input", {
                          attrs: { type: "textarea", rows: "4" },
                          model: {
                            value: _vm.formData.description,
                            callback: function ($$v) {
                              _vm.$set(_vm.formData, "description", $$v)
                            },
                            expression: "formData.description",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: "活动类型",
                          prop: "type",
                          "label-width": "120px",
                        },
                      },
                      [
                        _c(
                          "el-select",
                          {
                            attrs: { placeholder: "请选择活动类型" },
                            model: {
                              value: _vm.formData.type,
                              callback: function ($$v) {
                                _vm.$set(_vm.formData, "type", $$v)
                              },
                              expression: "formData.type",
                            },
                          },
                          [
                            _c("el-option", {
                              attrs: { label: "会员中心轮播", value: 0 },
                            }),
                            _vm._v(" "),
                            _c("el-option", {
                              attrs: { label: "个人中心轮播", value: 5 },
                            }),
                            _vm._v(" "),
                            _c("el-option", {
                              attrs: { label: "积分", value: 1 },
                            }),
                            _vm._v(" "),
                            _c("el-option", {
                              attrs: { label: "充值", value: 2 },
                            }),
                            _vm._v(" "),
                            _c("el-option", {
                              attrs: { label: "畅饮", value: 3 },
                            }),
                            _vm._v(" "),
                            _c("el-option", {
                              attrs: { label: "社区", value: 4 },
                            }),
                            _vm._v(" "),
                            _c("el-option", {
                              attrs: { label: "券膨胀", value: 6 },
                            }),
                            _vm._v(" "),
                            _c("el-option", {
                              attrs: { label: "小红书活动Banner", value: 7 },
                            }),
                            _vm._v(" "),
                            _c("el-option", {
                              attrs: {
                                label: "小红书创作指南（员工）",
                                value: 8,
                              },
                            }),
                            _vm._v(" "),
                            _c("el-option", {
                              attrs: {
                                label: "小红书创作指南（顾客）",
                                value: 9,
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: "活动图片",
                          prop: "imageUrl",
                          "label-width": "120px",
                        },
                      },
                      [
                        _c(
                          "el-upload",
                          {
                            staticClass: "upload-demo",
                            attrs: {
                              "http-request": _vm.handlePictureUpload,
                              action: "",
                              "on-remove": _vm.handleRemoveFile,
                              "on-preview": _vm.handlePreview,
                              "list-type": "picture-card",
                              "auto-upload": true,
                              accept: "image/*",
                              "file-list": _vm.uploadFileList,
                            },
                          },
                          [_c("i", { staticClass: "el-icon-plus" })]
                        ),
                        _vm._v(" "),
                        _vm.formData.type != 8 && _vm.formData.type != 9
                          ? _c("div", { staticClass: "upload-tip" }, [
                              _vm._v(
                                "图片格式：jpg/png，大小≤2MB，尺寸315px*120px,\n              或同比例图片\n            "
                              ),
                            ])
                          : _vm._e(),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: "跳转类型",
                          prop: "linkType",
                          "label-width": "120px",
                        },
                      },
                      [
                        _c(
                          "el-radio-group",
                          {
                            model: {
                              value: _vm.formData.linkType,
                              callback: function ($$v) {
                                _vm.$set(_vm.formData, "linkType", $$v)
                              },
                              expression: "formData.linkType",
                            },
                          },
                          [
                            _c("el-radio", { attrs: { label: 0 } }, [
                              _vm._v("小程序"),
                            ]),
                            _vm._v(" "),
                            _c("el-radio", { attrs: { label: 1 } }, [
                              _vm._v("gaga社区"),
                            ]),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: "跳转路径",
                          prop: "linkValue",
                          "label-width": "120px",
                        },
                      },
                      [
                        _c("el-input", {
                          model: {
                            value: _vm.formData.linkValue,
                            callback: function ($$v) {
                              _vm.$set(_vm.formData, "linkValue", $$v)
                            },
                            expression: "formData.linkValue",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: "排序值",
                          prop: "sortOrder",
                          "label-width": "120px",
                        },
                      },
                      [
                        _c("el-input-number", {
                          attrs: { min: 0 },
                          model: {
                            value: _vm.formData.sortOrder,
                            callback: function ($$v) {
                              _vm.$set(_vm.formData, "sortOrder", $$v)
                            },
                            expression: "formData.sortOrder",
                          },
                        }),
                        _vm._v(" "),
                        _c("div", { staticClass: "upload-tip" }, [
                          _vm._v("排序值：按升序进行排列"),
                        ]),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.dialog.status != "create"
                      ? _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: "启用状态",
                              prop: "enabled",
                              "label-width": "120px",
                            },
                          },
                          [
                            _c("el-switch", {
                              attrs: {
                                "active-color": "#13ce66",
                                "inactive-color": "#ff4949",
                              },
                              model: {
                                value: _vm.formData.enabled,
                                callback: function ($$v) {
                                  _vm.$set(_vm.formData, "enabled", $$v)
                                },
                                expression: "formData.enabled",
                              },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: "是否会员",
                          prop: "isVip",
                          "label-width": "120px",
                        },
                      },
                      [
                        _c(
                          "el-radio-group",
                          {
                            model: {
                              value: _vm.formData.isVip,
                              callback: function ($$v) {
                                _vm.$set(_vm.formData, "isVip", $$v)
                              },
                              expression: "formData.isVip",
                            },
                          },
                          [
                            _c("el-radio", { attrs: { label: 1 } }, [
                              _vm._v("是"),
                            ]),
                            _vm._v(" "),
                            _c("el-radio", { attrs: { label: 0 } }, [
                              _vm._v("否"),
                            ]),
                            _vm._v(" "),
                            _c("el-radio", { attrs: { label: 6 } }, [
                              _vm._v("不限"),
                            ]),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.formData.isVip === 1
                      ? _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: "会员等级",
                              "label-width": "120px",
                            },
                          },
                          [
                            _c(
                              "el-checkbox-group",
                              {
                                key: _vm.checkboxRenderKey,
                                on: { change: _vm.initVipLevelStrList },
                                model: {
                                  value: _vm.vipLevelStrList,
                                  callback: function ($$v) {
                                    _vm.vipLevelStrList = $$v
                                  },
                                  expression: "vipLevelStrList",
                                },
                              },
                              [
                                _c("el-checkbox", { attrs: { label: "1" } }, [
                                  _vm._v("普卡"),
                                ]),
                                _vm._v(" "),
                                _c("el-checkbox", { attrs: { label: "2" } }, [
                                  _vm._v("银卡"),
                                ]),
                                _vm._v(" "),
                                _c("el-checkbox", { attrs: { label: "3" } }, [
                                  _vm._v("金卡"),
                                ]),
                                _vm._v(" "),
                                _c("el-checkbox", { attrs: { label: "4" } }, [
                                  _vm._v("黑金卡"),
                                ]),
                                _vm._v(" "),
                                _c("el-checkbox", { attrs: { label: "5" } }, [
                                  _vm._v("钻石卡"),
                                ]),
                              ],
                              1
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: "是否添加企微",
                          prop: "isAddedWecom",
                          "label-width": "120px",
                        },
                      },
                      [
                        _c(
                          "el-radio-group",
                          {
                            model: {
                              value: _vm.formData.isAddedWecom,
                              callback: function ($$v) {
                                _vm.$set(_vm.formData, "isAddedWecom", $$v)
                              },
                              expression: "formData.isAddedWecom",
                            },
                          },
                          [
                            _c("el-radio", { attrs: { label: 1 } }, [
                              _vm._v("是"),
                            ]),
                            _vm._v(" "),
                            _c("el-radio", { attrs: { label: 0 } }, [
                              _vm._v("否"),
                            ]),
                            _vm._v(" "),
                            _c("el-radio", { attrs: { label: 6 } }, [
                              _vm._v("不限"),
                            ]),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: "是否下过单",
                          prop: "hasOrdered",
                          "label-width": "120px",
                        },
                      },
                      [
                        _c(
                          "el-radio-group",
                          {
                            model: {
                              value: _vm.formData.hasOrdered,
                              callback: function ($$v) {
                                _vm.$set(_vm.formData, "hasOrdered", $$v)
                              },
                              expression: "formData.hasOrdered",
                            },
                          },
                          [
                            _c("el-radio", { attrs: { label: 1 } }, [
                              _vm._v("是"),
                            ]),
                            _vm._v(" "),
                            _c("el-radio", { attrs: { label: 0 } }, [
                              _vm._v("否"),
                            ]),
                            _vm._v(" "),
                            _c("el-radio", { attrs: { label: 6 } }, [
                              _vm._v("不限"),
                            ]),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: "新人券是否过期",
                          prop: "isNewCouponExpired",
                          "label-width": "120px",
                        },
                      },
                      [
                        _c(
                          "el-radio-group",
                          {
                            model: {
                              value: _vm.formData.isNewCouponExpired,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.formData,
                                  "isNewCouponExpired",
                                  $$v
                                )
                              },
                              expression: "formData.isNewCouponExpired",
                            },
                          },
                          [
                            _c("el-radio", { attrs: { label: 1 } }, [
                              _vm._v("是"),
                            ]),
                            _vm._v(" "),
                            _c("el-radio", { attrs: { label: 0 } }, [
                              _vm._v("否"),
                            ]),
                            _vm._v(" "),
                            _c("el-radio", { attrs: { label: 6 } }, [
                              _vm._v("不限"),
                            ]),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: "生效时间",
                          required: "",
                          "label-width": "120px",
                          prop: "startTime",
                        },
                      },
                      [
                        _c("el-date-picker", {
                          staticStyle: { width: "100%" },
                          attrs: {
                            type: "datetime",
                            placeholder: "开始时间",
                            "picker-options": _vm.startPickerOptions,
                          },
                          model: {
                            value: _vm.formData.startTime,
                            callback: function ($$v) {
                              _vm.$set(_vm.formData, "startTime", $$v)
                            },
                            expression: "formData.startTime",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: "结束时间",
                          required: "",
                          "label-width": "120px",
                          prop: "endTime",
                        },
                      },
                      [
                        _c("el-date-picker", {
                          staticStyle: { width: "100%" },
                          attrs: {
                            type: "datetime",
                            placeholder: "结束时间",
                            "picker-options": _vm.endPickerOptions,
                          },
                          model: {
                            value: _vm.formData.endTime,
                            callback: function ($$v) {
                              _vm.$set(_vm.formData, "endTime", $$v)
                            },
                            expression: "formData.endTime",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "drawer-footer" },
              [
                _c("el-button", { on: { click: _vm.handleDrawerClose } }, [
                  _vm._v("取消"),
                ]),
                _vm._v(" "),
                _c(
                  "el-button",
                  { attrs: { type: "primary" }, on: { click: _vm.submitForm } },
                  [_vm._v("提交")]
                ),
              ],
              1
            ),
          ]),
        ]
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: { visible: _vm.previewDialog.visible, width: "400px" },
          on: {
            "update:visible": function ($event) {
              return _vm.$set(_vm.previewDialog, "visible", $event)
            },
          },
        },
        [
          _c("img", {
            staticStyle: { width: "100%" },
            attrs: { src: _vm.previewDialog.url, alt: "预览图" },
          }),
        ]
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }